<div class="page-section py-3 justify-content-center p-2 m-auto">
    <div class="d-flex flex-column px-2 py-5 px-sm-3 px-md-4 px-lg-5 bg-white shadow rounded-lg">
        <div class="title h2 mb-4">Avextra JUPITER</div>
        <p>Inserire l'ID Medico JUPITER e la password.</p>
        <p>Quando ci si registra per la prima volta, si prega di utilizzare le informazioni fornite dall'Organizzazione degli studi Jupiter. Si tratta di una password temporanea che verrà sostituita da una password di vostra scelta per la registrazione al sondaggio online.</p>

        <div class="page-form">
            <form [formGroup]="loginForm" (ngSubmit)="loginUser()">
                <div class="form-group">
                    <label>ID Medico JUPITER</label>
                    <input type="text" class="form-control" formControlName="UserName" autocomplete="new-password" />

                    <ng-container *ngIf="getErrorMsg('UserName')">
                        <small class="form-text text-danger">{{getErrorMsg('UserName')}}</small>
                    </ng-container>
                </div>
                <div class="form-group">
                    <label>Password</label>
                    <div class="input-group">
                        <input type="password" class="form-control" #passwordField formControlName="Password"
                               autocomplete="new-password" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-sm btn-light border px-2 py-1"
                                    (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'">
                                <img src="assets/icons/eye.svg" style="width: 20px;"
                                     [class.d-none]="passwordField.type === 'text'" />
                                <img src="assets/icons/eye-slash.svg" style="width: 20px;"
                                     [class.d-none]="passwordField.type === 'password'" />
                            </button>
                        </div>
                    </div>

                    <ng-container *ngIf="getErrorMsg('Password')">
                        <small class="form-text text-danger">{{getErrorMsg('Password')}}</small>
                    </ng-container>
                </div>

                <div class="form-group">
                    <div class="d-flex flex-column flex-md-row justify-content-between error-button-block">
                        <div class="error-block">
                            <div class="d-flex flex-row align-items-center" *ngIf="loginError">
                                <img src="assets/icons/Info Revert.svg" alt="Info Revert" />
                                <div>
                                    <div class="error-text">
                                        Si è verificato un errore! Inserisci l'ID medico e la password.
                                    </div>
                                    <div class="error-info">
                                        Se il problema persiste, contatta l'organizzazione dello studio JUPITER.
                                        <a class="error-text" href="mailto:clinical.operations.it@avextra.com" target="_blank">Email</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="button-block">
                            <button [disabled]="formDisabled" type="submit" class="standard-btn pad-20">Conferma</button>
                        </div>
                    </div>

                </div>
            </form>
        </div>

        <div class="footer-links">
            <ul>
                <li>
                    <a href="https://copeia.de/private/avextra/datenschutz" target="_blank">Protezione dei Dati</a>
                </li>
                <li>
                    <a href="mailto:clinical.operations.it@avextra.com" target="_blank">Contatto</a>
                </li>
            </ul>
        </div>
    </div>
</div>
